import exportService from "@exportService";
import * as Ably from "ably";

export const createAblyClient = (clientId: string) => {
  return new Ably.Realtime({
    authCallback: async (tokenParams, callback) => {
      try {
        const response: any = await exportService.socket.authorize(clientId);
        const token = response?.token;
        if (!token) {
          callback("No auth token available for Ably", null);
          return;
        }
        callback(null, token);
      } catch (error: unknown) {
        if (error) {
          callback(error as any, null);
        }
      }
    },
    clientId: clientId,
    closeOnUnload: false,
  });
};

export const closeAblyConnection = (client: any) => {
  if (client) {
    client.close();
  }
};
